"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const react_hook_form_2 = require("react-hook-form");
const iconoir_react_1 = require("iconoir-react");
const react_code_input_1 = __importDefault(require("react-code-input"));
// import app components
const button_1 = __importDefault(require("../../elements/button"));
const authTemplate_1 = __importDefault(require("../../combinations/authTemplate"));
const input_1 = __importDefault(require("../../elements/input"));
const theme_1 = require("../../../theme");
const ResetPassword = (props) => {
    const { quote, authorOrRole, description, backgroundImage, message, loading, linkComponent, loginLink, component = "forgetPassword", onSubmitForgetPassword, onSubmitResetPassword, email, } = props;
    const { handleSubmit, control, watch } = (0, react_hook_form_1.useForm)();
    const [showPassword1, setShowPassword1] = (0, react_1.useState)(false);
    const [showPassword2, setShowPassword2] = (0, react_1.useState)(false);
    const handleTogglePassword1 = () => {
        setShowPassword1(!showPassword1);
    };
    const handleTogglePassword2 = () => {
        setShowPassword2(!showPassword2);
    };
    const renderComponent = () => {
        switch (component) {
            case "forgetPassword":
                return (react_1.default.createElement("form", { key: "forgetPassword", method: "post", "data-testid": "forgetPasswordForm", noValidate: true, onSubmit: (e) => {
                        e.preventDefault();
                        !loading && handleSubmit(onSubmitForgetPassword)(e);
                    } },
                    react_1.default.createElement(material_1.Stack, { spacing: 4 },
                        react_1.default.createElement(react_hook_form_2.Controller, { name: "email", control: control, rules: {
                                required: "Please enter your email address",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Please enter a valid email",
                                },
                            }, render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Email", inputProps: { "data-testid": "email" }, placeholder: "johndoe@workemail.com", onChange: onChange, error: !!error, helperText: error ? error.message : null, type: "email", fullWidth: true })) }),
                        react_1.default.createElement(button_1.default, { fullWidth: true, loading: loading, variant: "outlined", type: "submit", "data-testid": "forgetPasswordButton" }, "Reset"))));
            case "resetPassword":
                return (react_1.default.createElement("form", { key: "resetPassword", method: "post", "data-testid": "resetPasswordForm", noValidate: true, onSubmit: (e) => {
                        e.preventDefault();
                        !loading && handleSubmit(onSubmitResetPassword)(e);
                    } },
                    react_1.default.createElement(material_1.Stack, { spacing: 4 },
                        react_1.default.createElement(react_hook_form_2.Controller, { name: "confirmationCode", control: control, defaultValue: "", render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(material_1.Box, null,
                                react_1.default.createElement(material_1.InputLabel, null, "Confirmation Code"),
                                react_1.default.createElement(material_1.Box, { sx: {
                                        "> div": {
                                            display: "flex !important",
                                            justifyContent: "space-between",
                                        },
                                    } },
                                    react_1.default.createElement(react_code_input_1.default, { name: "pin", type: "tel", fields: 6, inputMode: "tel", onChange: onChange, autoFocus: false, inputStyle: {
                                            border: `1px solid ${theme_1.colors.border[700]}`,
                                            width: "calc(100% / 6 - 10px)",
                                            background: "transparent",
                                            borderRadius: "1rem",
                                            textAlign: "center",
                                            position: "relative",
                                            height: "50px",
                                            color: "#ffffff",
                                            marginTop: "4px",
                                            MozAppearance: "textfield",
                                            fontSize: "18px",
                                            outline: "none",
                                        } })),
                                error && (react_1.default.createElement(material_1.Typography, { variant: "caption", color: "error" }, error.message)))), rules: {
                                required: "Confirmation code required",
                                validate: (value) => {
                                    if (value.length !== 6) {
                                        return "Pin must be 6 digits";
                                    }
                                },
                            } }),
                        react_1.default.createElement(react_hook_form_2.Controller, { name: "password", control: control, defaultValue: "", render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Password", inputProps: { "data-testid": "password1" }, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", error: !!error, helperText: error ? error.message : null, type: showPassword1 ? "text" : "password", endIcon: showPassword1 ? react_1.default.createElement(iconoir_react_1.EyeEmpty, null) : react_1.default.createElement(iconoir_react_1.EyeOff, null), fullWidth: true, onChange: onChange, onClick: handleTogglePassword1 })), rules: { required: "Password required" } }),
                        react_1.default.createElement(react_hook_form_2.Controller, { name: "confirmPassword", control: control, defaultValue: "", render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Confirm Password ", inputProps: { "data-testid": "password2" }, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", error: !!error, helperText: error ? error.message : null, type: showPassword2 ? "text" : "password", endIcon: showPassword2 ? react_1.default.createElement(iconoir_react_1.EyeEmpty, null) : react_1.default.createElement(iconoir_react_1.EyeOff, null), fullWidth: true, onChange: onChange, onClick: handleTogglePassword2 })), rules: {
                                required: "Password required",
                                validate: (value) => {
                                    if (watch("password") !== value) {
                                        return "Your passwords do no match";
                                    }
                                },
                            } }),
                        react_1.default.createElement(material_1.Alert, { severity: "info" }, "Password must be minimum 8 characters, include numbers, uppercase and lowercase letters."),
                        react_1.default.createElement(button_1.default, { fullWidth: true, loading: loading, variant: "outlined", type: "submit", "data-testid": "passwordResetButton" }, "Reset"))));
            case "activateProfile":
                return (react_1.default.createElement(material_1.Alert, { severity: "success" },
                    "We sent an email to ",
                    email,
                    ". Click the link inside to activate your account. Check your spam folder if you haven't gotten it yet!"));
            case "successfulPasswordReset":
                return (react_1.default.createElement(material_1.Alert, { severity: "success" }, "Password has been reset successfully. You can now login with the new credentials."));
        }
    };
    return (react_1.default.createElement(authTemplate_1.default, { quote: quote, authorOrRole: authorOrRole, description: description, backgroundImage: backgroundImage, message: message, linkComponent: linkComponent, loginLink: loginLink, loginLinkTitle: "Back to Login" }, renderComponent()));
};
exports.default = ResetPassword;
